import script from "./ProductCatalogListingFigma.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCatalogListingFigma.vue?vue&type=script&setup=true&lang=js"

import "./ProductCatalogListingFigma.vue?vue&type=style&index=0&id=07d12f8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d12f8f"]])

export default __exports__
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerDots,QIcon,QPagination});
